export { findMessagePlatform, messagePlatforms } from './findMessagePlatform'
